module.exports = __webpack_public_path__ + "img/world-network-600x250.7e8c8ae2.png";